const BASE_URL = 'https://maps.googleapis.com/maps/api/staticmap?';

const DEFAULT_CONFIG = {
  scale: 2,
  maptype: 'roadmap',
  size: '600x450'
};

const createMakerAttrs = attrs => {
  const markerAttrs = [];
  if (attrs.icon) {
    markerAttrs.push(`icon:${attrs.icon}`);
  }

  if (attrs.color) {
    markerAttrs.push(`color:${attrs.color}`);
  }

  markerAttrs.push(`${attrs.lat},${attrs.lng}`);

  return markerAttrs.join('|');
};

class StaticMapsAPI {
  constructor(mapId, params = {}) {
    this.params = { ...DEFAULT_CONFIG, ...params };
    this.markers = {};
  }

  addMarker = (markerId, opts) => {
    this.markers[markerId] = createMakerAttrs(opts);
  };

  removeMarker = markerId => {
    this.markers[markerId] = null;
  };

  setCenter = ({ lat, lng }) => {
    this.params.center = `${lat},${lng}`;
  };

  generateURL = () => {
    const paramsAttrs = Object.keys(this.params)
      .filter(param => this.params[param])
      .map(key => `${key}=${this.params[key]}`);

    const markerAttrs = Object.keys(this.markers)
      .filter(marker => this.markers[marker])
      .map(marker => `markers=${this.markers[marker]}`);

    return BASE_URL + encodeURI([...paramsAttrs, ...markerAttrs].join('&'));
  };
}

export default StaticMapsAPI;
